import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';

/** getTitle */
interface GetTitleArgs {
  /** 求人タイトル */
  title: TopicJob['title'];
  /** 現在のページ番号 */
  currentPage: number;
}

/**
 * タイトルを生成する関数
 *
 * @param {GetTitleArgs} params - 引数のオブジェクト
 * @returns {string} 生成されたタイトル文字列
 */
export const getTitle = ({ title, currentPage }: GetTitleArgs) => {
  if (!title) return '求人特集 - 転職・求人情報 - doda';

  if (currentPage >= 2)
    return `${currentPage}ページ｜${title} - 転職・求人情報 - doda`;
  return `${title} - 転職・求人情報 - doda`;
};
